<template>
  <v-container fluid>
    <v-card flat class="applications">
      <v-card-text>
        <v-data-table
          id="scollStyle"
          ref="applications_list"
          :headers="headers"
          :items="applications"
          :sort-desc="[false, true]"
          multi-sort
          class="elevation-0 table-applications"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>My Applications</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:[`item.remarks`]="{ item }">
            <span class="font-weight-bold">{{ item["remarks"] }}</span>
          </template>
          <!--eslint-disable-next-line -->
          <template v-slot:[`item.status`]="{ item }">
            <span>
              <v-icon
                size="14"
                :color="statusColor[item.status.toLowerCase().trim()]"
              >
                mdi-radiobox-marked
              </v-icon>
              {{ statusWordings(item.status) }}
            </span>
          </template>
          <!--eslint-disable-next-line -->

          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'ApplicationDocument',
                    params: { appid: item.applicationID },
                  }"
                >
                  <v-icon color="primary" class="mr-1">mdi-eye</v-icon>
                  View
                </v-list-item>
                <v-divider />
                <v-list-item
                  :to="{
                    name: 'Proforma',
                    params: { appid: item.applicationID },
                  }"
                >
                  <v-icon color="warning" class="mr-1">mdi-form-select</v-icon>
                  Proforma
                </v-list-item>
                <v-divider />
                <v-list-item v-if="!item.postedReceiptNo" @click="pay(item)">
                  <v-icon color="error" class="mr-1">payment</v-icon>
                  Pay
                </v-list-item>
                <v-list-item
                  v-else
                  :to="{
                    name: 'Receipts',
                    params: { appid: item.postedReceiptNo },
                  }"
                >
                  <v-icon color="primary">mdi-script</v-icon>
                  Receipt
                </v-list-item>
                <v-list-item
                  v-if="item.status === 'OnHold'"
                  @click="patchApplication(item)"
                >
                  <v-icon color="primary">autorenew</v-icon>
                  Re-Submit
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
    </v-card>
    <app-alert />
  </v-container>
</template>

<script>
import { AuthService } from "../../dashboard/modules/auth";
import status from "../status";
import appAlert from "../../dashboard/plugins/appAlert/appAlert.vue";
// import axios from "axios";
export default {
  name: "MyApplicationsComponent",
  components: { appAlert },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch(
        "Application/getAllApplications",
        v.user.profile.profileID,
      );
      window.document.title = "KISEB::My Applications";
    });
  },

  computed: {
    user() {
      return AuthService.user;
    },
    applications() {
      return this.$store.getters["Application/appGetters"]("applications");
    },
    statusColor() {
      return status;
    },
    headers() {
      return [
        {
          text: "#S/N",
          sortable: true,
          value: "applicationID",
        },
        { text: "Applied On", sortable: true, value: "applicationDate" },
        {
          text: "Semester",
          sortable: true,
          value: "semester",
        },
        {
          text: "Programme",
          sortable: true,
          value: "programme",
        },
        {
          text: "Stage",
          sortable: true,
          value: "stage",
        },
        {
          text: "Status",
          sortable: true,
          value: "status",
        },
        {
          text: "Remarks",
          sortable: false,
          value: "remarks",
        },
        {
          text: "Actions",
          sortable: true,
          value: "action",
        },
      ];
    },
  },
  methods: {
    pay: function (app) {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;
      this.$confirm.show({
        title: "Application Payment",
        rejectLabel: "Cancel",
        text: `Application Payment for application No. ${app.applicationID}`,
        onConfirm: () => {
          let payload = {
            payerID: app.profileID,
            serviceID: app.serviceRequestCode,
            sourceDocumentNo: app.applicationID,
            description: "Application Payment",
            amount:
              app.amountToInvoice === 0 ? "1" : app.amountToInvoice.toString(),
            // accountNo: this.user["phone_number"],
            accountNo: PhoneNo,
            email: this.user.profile.email,
            idNumber: this.user.profile.identificationDocumentNo,
            name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "MyApplications" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          // window.location.href = `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`;
          this.$checkout.pay(payload);
        },
        onCancel: () => {
          Event.$emit("ApiError", "Payment cancelled");
        },
      });
    },
    statusWordings(status) {
      return status === "Draft" ? "In progress" : status;
    },
    patchApplication: function (val) {
      const data = { applicationID: val.applicationID, status: "Draft" };
      this.$store.dispatch("Application/patchApplication", data);
    },
  },
  watch: {
    applications() {
      this.applications.map((item) => {
        if (item.status === "OnHold") {
          this.$alert({
            title: "Application On Hold",
            text: "Kindly Resubmit your on Hold application to update your application status",
            onClose: () => {
              this.patchApplication(item);
            },
          });
        }
      });
    },
  },
};
</script>

<style scoped>
@import url("../styles/applications.css");
</style>
